import { _smartbom_manipulator_add_draftel, _smartbom_manipulator_init_make_smartbom, _smartbom_validator_quick_incomplete } from "../utils/frfr-smartbom-utils";
import { virbomCounter } from "../utils/frfr-virbom-counter-utils";
import { _virbom_manipulator, _virbom_validator } from "../utils/frfr-virbom-manipulator-utils";
import { _draftel_codecs_datarender_virbom_from_single_draftel } from "./ter-draftel-codec-lib";
import { _getTerkkCparamsDefaultFromLib } from "./ter-params-utils";
import { terUtilsSortirajDrafteleKonzistentnimRedosledom } from "./ter-redosled-utils";
import { _dopuni_virbom_seq_sa_simuliranim_radnim_nalozima } from "./ter-simulacija-radnih-naloga-utils";
import { terUtils_make_smartbom_manifest_terkk_v1_0 } from "./ter-smartbom-utils";
import { terUtils_extract_cena_po_jm_from_virtel, terUtils_extract_masa_po_jm_from_virtel } from "./ter-utils";
import { _dopuni_virbom_seq_sa_kumulativnim_vremenima } from "./ter-virbom-vremena-utils";


// NOVO 2023 MAJ


export const _datarender_virbom_from_single_virtel = (virtel) => {
  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, virtel);
  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  return virbom_seq;
};


export const _enrich_virtel_from_unbundled_subDraftel_arr_with_fresh_subkey = (virtel) => {
  // virtel koji je nastao od _unbundled_subDraftel_arr nema subkey jer je on nastao iz _subform_arr od draftela i oni koriste tempkey-eve uemsto subkey-eva. Zbog toga mu sada dodeljujemo subkey.
  return {
    ...virtel,
    subkey: virbomCounter.generateFreshSubkey()
  };
};


const _generate_fresh_subkey = (maxSubkey) => {
  let _maxSubkey = 0;
  if (maxSubkey > 0) {
    _maxSubkey = maxSubkey;
  }
  const newSubkey = virbomCounter.generateFreshSubkey(maxSubkey); // number subkey
  return newSubkey;
};


/*
export const _datarender_virbom_from_single_modul_virtel = (virtel) => {

};
*/


// ----- DATARENDER GLOBAL VIRBOM FROM SMARTBOM
const _smartbom_traversing_utils_datarender_global_virbom = (smartbom) => {
  //
  //
  const smartel_arr = smartbom.children_smartel_arr;
  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);
  let counter = 0;
  //
  //
  // _generate_fresh_subkey = virbomCounter.generateFreshSubkey;
  const _generate_fresh_subkey = false; // iskljucujemo jer ne zelimo da se pri virbom merge dodeljuju novi subkey-evi.
  //
  //
  const _tree_smartel_single = (smartel, this_graphlevel) => {
    counter++;
    console.log('single smartel', counter, ' to RENDER', smartel);
    if (virbom_ref.length === 0) {
      // initial virtel
      if (Array.isArray(smartel.self.virbom)) {
        virbom_ref = [...smartel.self.virbom];
      }
    } else {
      if (Array.isArray(smartel.self.virbom)) {
        const slave_virtel_arr = smartel.self.virbom;
        console.log('broj novih virtela', slave_virtel_arr.length);
        _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, slave_virtel_arr, smartel.graphlevel, _generate_fresh_subkey);
      } else {
        console.log('SKIP smartel.self.virbom null');
      }
    }
    console.log('broj renderovanih virtela:', virbom_ref.length);
    //
    // korak children
    const target_graphlevel = this_graphlevel + 1;
    _tree_smartel_each(smartel.children_smartel_arr, target_graphlevel);
  }; // end of _dirty_tree_smartel_single
  //
  const _tree_smartel_each = (smartel_arr, target_graphlevel) => {
    console.log('smartel_arr to RENDER', smartel_arr);
    smartel_arr.forEach((smartel) => {
      // *EACH
      if (smartel.enabled === true) {
        _tree_smartel_single(smartel, target_graphlevel);
      } else {
        // smartel disabled
        // skip rendering disabled smartel
      }
    });
  }; //
  // START TRAVERSING
  _tree_smartel_each(smartel_arr, 1); // start from root level 1
  //
  // FINALIZING VIRBOM
  let virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  console.log('UKUPNO renderovanih virtela:', virbom_seq.length);
  //
  // SAD DOPUNJAVAMO PODATKE ZA KOJE JE POTREBAN BIDIRECTIONAL-TRAVERSING KROZ CEO VIRBOM
  // RACUNAMO UKUPNE KOLICINE ZA RADNE NALOGE
  virbom_seq = _dopuni_virbom_seq_sa_simuliranim_radnim_nalozima(virbom_seq);
  // NA KRAJU RACUNAMO VREMENA KUMULATIVNA koja uzimaju u obzir prethodno izracunate kolicina ukupne
  virbom_seq = _dopuni_virbom_seq_sa_kumulativnim_vremenima(virbom_seq, terUtils_extract_masa_po_jm_from_virtel, terUtils_extract_cena_po_jm_from_virtel);
  console.log('AFTER TREE UPDATE global virbom_seq', virbom_seq);
  return [...virbom_seq]; // PURE NEW REFERENCE
};


//
export const _datarender_virbom_from_smartbom = (smartbom) => {
  console.log('--------------------');
  console.log('_datarender_virbom_from_smartbom(smartbom)', smartbom);
  //
  if (_smartbom_validator_quick_incomplete(smartbom)) {
    console.log('smartbom is valid :)');
    const virbom_seq = _smartbom_traversing_utils_datarender_global_virbom(smartbom);
    _virbom_validator(virbom_seq);
    console.log('--------------------');
    return virbom_seq;
  } else {
    // ERROR
    console.log('ERROR _smartbom_validator_quick_incomplete() FAIL. Not valid smartbom object. We will return empty virbom_seq');
    console.log('--------------------');
    return [];
  }
};


//
export const _convert_smartbom_to_draftel_arr = (smartbom) => {
  console.log('_convert_smartbom_to_draftel_arr(smartbom)', smartbom);
  //
  const smartel_arr = smartbom.children_smartel_arr;
  let draftel_arr = [];
  //
  const _tree_smartel_single = (smartel, this_graphlevel) => {
    draftel_arr.push(smartel.self.draftel);
    //
    // korak children
    const target_graphlevel = this_graphlevel + 1;
    _tree_smartel_each(smartel.children_smartel_arr, target_graphlevel);
  }; // end of _dirty_tree_smartel_single
  //
  const _tree_smartel_each = (smartel_arr, target_graphlevel) => {
    console.log('smartel_arr to RENDER', smartel_arr);
    smartel_arr.forEach((smartel) => {
      // *EACH
      _tree_smartel_single(smartel, target_graphlevel);
    });
  }; //
  // START TRAVERSING
  _tree_smartel_each(smartel_arr, 1); // start from root level 1
  //
  // FINALIZING
  //
  console.log('draftel_arr (from smartbom) conversion completed', draftel_arr);
  return draftel_arr;
};


// NE KORISTI SE VIŠE
export const _convert_draftel_arr_to_smartbom = (draftel_arr) => {
  console.log('_convert_draftel_arr_to_smartbom(draftel_arr)', draftel_arr);
  //
  const default_smartbom_cparams = _getTerkkCparamsDefaultFromLib();
  let smartbom = _smartbom_manipulator_init_make_smartbom(terUtils_make_smartbom_manifest_terkk_v1_0(), default_smartbom_cparams);
  //
  draftel_arr.forEach((draftel) => {
    smartbom = _smartbom_manipulator_add_draftel(smartbom, draftel, draftel.parent_subkey, terUtilsSortirajDrafteleKonzistentnimRedosledom, _draftel_codecs_datarender_virbom_from_single_draftel);
  });
  //
  // FINALIZING
  console.log('smartbom (from draftel_arr) conversion completed', smartbom);
  return smartbom;
};

